import React from 'react';
import Explainer from '../blocks';

import styles from './MigrateLegal.module.css';

const EXPLAINER_WIDTH = 662;
const EXPLAINER_HEIGHT = 460;

const MigrateLegal = () => {
  return (
    <Explainer
      width={EXPLAINER_WIDTH}
      height={EXPLAINER_HEIGHT}
      className={styles.root}
      once
    >
      <g className={styles.container}>
        <g transform="translate(55 145)">
          <g filter="url(#filter0_d_3617_9082)" className={styles.one}>
            <g clipPath="url(#clip0_3617_9082)">
              <rect
                width="218"
                height="60"
                transform="translate(21 16.2148)"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M51 38.2148H35V54.2148H51V38.2148ZM47.8 41.0148H38.2V51.4148H43V43.4148H45.4V51.4148H47.8V41.0148Z"
                fill="#5B798A"
              />
              <text
                fill="#092F45"
                fontFamily="var(--font-family-body)"
                fontSize="16"
                letterSpacing="0.005em"
              >
                <tspan x="59" y="50.8548">
                  numeral
                </tspan>
              </text>
              <text
                fill="#5B798A"
                fontFamily="var(--font-family-mono)"
                fontSize="14"
                letterSpacing="0.0075em"
              >
                <tspan x="121" y="51.1148">
                  @0.19.27
                </tspan>
              </text>
              <mask id="path-5-inside-1_3617_9082" fill="white">
                <path d="M239 16.2148H392V76.2148H239V16.2148Z" />
              </mask>
              <path d="M239 16.2148H392V76.2148H239V16.2148Z" fill="white" />
              <path
                d="M240 76.2148V16.2148H238V76.2148H240Z"
                fill="#E1EAF3"
                mask="url(#path-5-inside-1_3617_9082)"
              />
              <text
                fill="#2A6FE1"
                fontFamily="var(--font-family-mono)"
                fontSize="12"
                letterSpacing="0em"
              >
                <tspan x="249" y="50.4148">
                  MIT License
                </tspan>
              </text>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M346.888 47.9655L351.922 42.9312L351.922 46.6118L352.922 46.6118L352.922 42.2696L351.877 41.2241L347.535 41.2241L347.535 42.2241L351.215 42.2241L346.181 47.2584L346.888 47.9655ZM345.085 43.4122H345.634V42.4122H344.671L344.525 42.5586L343.078 44.0051L343.078 47.9781L343.078 49.6123L344.671 51.2053H345.099H346.569H350.278L351.871 49.6123L351.871 48.6952L350.871 48.6952L350.871 49.1981L349.864 50.2053H346.569H345.099H345.085L344.078 49.1981V48.5163L344.078 44.4193L345.085 43.4122Z"
                fill="#5B798A"
              />
              <mask id="path-9-inside-2_3617_9082" fill="white">
                <path d="M392 16.2148H532V76.2148H392V16.2148Z" />
              </mask>
              <path d="M392 16.2148H532V76.2148H392V16.2148Z" fill="white" />
              <path
                d="M393 76.2148V16.2148H391V76.2148H393Z"
                fill="#E1EAF3"
                mask="url(#path-9-inside-2_3617_9082)"
              />
              <rect
                x="408"
                y="34.7148"
                width="83"
                height="23"
                rx="4"
                fill="#E2FCF0"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M421.46 48.9904L425.48 43.8312L424.938 43.4087L421.124 48.3029L420.654 48.3029L418.318 45.6629L417.803 46.1185L420.344 48.9904L421.46 48.9904Z"
                fill="#007C68"
              />
              <text
                fill="#007C68"
                fontFamily="var(--font-family-mono)"
                fontSize="10"
                letterSpacing="0.04em"
              >
                <tspan x="431.186" y="49.7148">
                  APPROVED
                </tspan>
              </text>
            </g>
          </g>
          <g filter="url(#filter1_d_3617_9082)" className={styles.two}>
            <g clipPath="url(#clip1_3617_9082)">
              <rect
                width="218"
                height="60"
                transform="translate(20 94.4297)"
                fill="white"
              />
              <path
                d="M38.7756 121.263L38.7653 121.253L36.4877 123.473L42.0176 128.852L44.2952 126.642L47.5475 123.473L45.2699 121.253V121.243H38.7653L38.7756 121.263Z"
                fill="#5B798A"
              />
              <path
                d="M41.9971 115.333L33.9434 119.832V128.832L41.9971 133.332L50.0509 128.832V119.832L41.9971 115.333ZM48.5119 127.972L41.9971 131.632L35.4822 127.972V120.672L41.9971 117.012L48.5119 120.672V127.972Z"
                fill="#5B798A"
              />
              <text
                fill="#092F45"
                fontFamily="var(--font-family-body)"
                fontSize="16"
                letterSpacing="0.005em"
              >
                <tspan x="58" y="129.07">
                  react-scripts
                </tspan>
              </text>
              <text
                fill="#5B798A"
                fontFamily="var(--font-family-mono)"
                fontSize="14"
                letterSpacing="0.0075em"
              >
                <tspan x="152" y="129.33">
                  @3.16.46
                </tspan>
              </text>
              <mask id="path-18-inside-3_3617_9082" fill="white">
                <path d="M238 94.4297H391V154.43H238V94.4297Z" />
              </mask>
              <path d="M238 94.4297H391V154.43H238V94.4297Z" fill="white" />
              <path
                d="M239 154.43V94.4297H237V154.43H239Z"
                fill="#E1EAF3"
                mask="url(#path-18-inside-3_3617_9082)"
              />
              <text
                fill="#2A6FE1"
                fontFamily="var(--font-family-mono)"
                fontSize="12"
                letterSpacing="0em"
              >
                <tspan x="248" y="128.63">
                  GNU GPL 2.0
                </tspan>
              </text>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M345.888 126.18L350.922 121.146L350.922 124.827L351.922 124.827L351.922 120.484L350.877 119.439L346.535 119.439L346.535 120.439L350.215 120.439L345.181 125.473L345.888 126.18ZM344.085 121.627H344.634V120.627H343.671L343.525 120.773L342.078 122.22L342.078 126.193L342.078 127.827L343.671 129.42H344.099H345.569H349.278L350.871 127.827L350.871 126.91L349.871 126.91L349.871 127.413L348.864 128.42H345.569H344.099H344.085L343.078 127.413V126.731L343.078 122.634L344.085 121.627Z"
                fill="#5B798A"
              />
              <mask id="path-22-inside-4_3617_9082" fill="white">
                <path d="M391 94.4297H532V154.43H391V94.4297Z" />
              </mask>
              <path d="M391 94.4297H532V154.43H391V94.4297Z" fill="white" />
              <path
                d="M392 154.43V94.4297H390V154.43H392Z"
                fill="#E1EAF3"
                mask="url(#path-22-inside-4_3617_9082)"
              />
              <rect
                x="407"
                y="112.93"
                width="109"
                height="23"
                rx="4"
                fill="#FFF2F5"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M420.014 124.43L417.826 126.617L418.312 127.103L420.5 124.916L422.688 127.103L423.174 126.617L420.986 124.43L423.174 122.242L422.688 121.756L420.5 123.943L418.312 121.756L417.826 122.242L420.014 124.43Z"
                fill="#B73B55"
              />
              <text
                fill="#B73B55"
                fontFamily="var(--font-family-mono)"
                fontSize="10"
                letterSpacing="0.04em"
              >
                <tspan x="430.179" y="127.93">
                  NOT APPROVED
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>

      <defs>
        <filter
          id="filter0_d_3617_9082"
          x="1"
          y="0.214844"
          width="551"
          height="100"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.164706 0 0 0 0 0.435294 0 0 0 0 0.882353 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3617_9082"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3617_9082"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3617_9082"
          x="0"
          y="78.4297"
          width="552"
          height="100"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.164706 0 0 0 0 0.435294 0 0 0 0 0.882353 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3617_9082"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3617_9082"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3617_9082">
          <path
            d="M21 22.2148C21 18.9011 23.6863 16.2148 27 16.2148H526C529.314 16.2148 532 18.9011 532 22.2148V70.2148C532 73.5286 529.314 76.2148 526 76.2148H27C23.6863 76.2148 21 73.5286 21 70.2148V22.2148Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_3617_9082">
          <path
            d="M20 100.43C20 97.116 22.6863 94.4297 26 94.4297H526C529.314 94.4297 532 97.116 532 100.43V148.43C532 151.743 529.314 154.43 526 154.43H26C22.6863 154.43 20 151.743 20 148.43V100.43Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </Explainer>
  );
};

export default MigrateLegal;
